<template>
	<div
		class="prest-row-image d-none d-md-flex cursor-pointer col-md-3 col-lg-2 pe-md-0"
	>
		<div
			@click="$emit('plusInfosClick')"
			class="prestation-image-wrapper d-flex justify-content-center position-relative align-items-center"
		>
			<template v-if="isDisplayPlaceholders">
				<PlaceholderBox :minHeight="'120px'" />
			</template>
			<template v-else>
				<img
					class="prestation-image w-100 h-100"
					:src="src"
					alt="prestation-image"
					style="border-radius: var(--border-radius-card)"
				/>
				<svg
					class="search-icon"
					width="65"
					height="65"
					viewBox="0 0 71 71"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g clip-path="url(#clip0_4994_11430)">
						<path
							d="M39.8693 39.6868C44.7785 34.7776 44.7893 26.8289 39.8933 21.9329C34.9973 17.0369 27.0486 17.0476 22.1394 21.9568C17.2302 26.866 17.2195 34.8147 22.1155 39.7107C27.0115 44.6067 34.9601 44.596 39.8693 39.6868Z"
							fill="white"
							fill-opacity="0.8"
						/>
						<path
							d="M51.7784 0H19.2283C8.60606 0 0 8.60606 0 19.2283V51.7784C0 62.3939 8.60606 71.0068 19.2283 71.0068H51.7784C62.3939 71.0068 71.0068 62.4007 71.0068 51.7784V19.2283C71.0068 8.61283 62.4007 0 51.7784 0ZM56.6024 56.7716C56.1424 57.2317 55.5334 57.4685 54.9313 57.4685C54.3291 57.4685 53.7202 57.2384 53.2601 56.7716L41.2441 44.7488C38.0778 47.0762 34.0927 48.3617 29.81 48.064C21.3528 47.4889 14.4517 40.669 13.7819 32.2186C12.9362 21.5828 21.7858 12.7399 32.4148 13.5789C40.642 14.2284 47.3739 20.7912 48.2129 29.0049C48.6932 33.7071 47.2724 38.071 44.6338 41.4471L56.6024 53.4225C57.5293 54.3494 57.5293 55.8447 56.6024 56.7716Z"
							fill="white"
							fill-opacity="0.8"
						/>
					</g>
					<defs>
						<clipPath id="clip0_4994_11430">
							<rect width="71" height="71" fill="white" />
						</clipPath>
					</defs>
				</svg>
			</template>
		</div>
	</div>
</template>

<script>
import PlaceholderBox from "@/vue/planning/components/common/placeholderBox.vue";
import iconSizes from "@/config/iconSizes";
import colors from "@/config/colors";

export default {
	name: "PictureDesktop",
	props: {
		src: String,
		isDisplayPlaceholders: {
			type: Boolean,
			default: false,
		},
		selected: Boolean,
	},
	data() {
		return {
			colors,
			iconSizes,
		};
	},
	components: {
		PlaceholderBox,
	},
};
</script>

<style scoped>
.prestation-image-wrapper {
	height: 198px;
	width: 176px;
}

.prestation-image {
	object-fit: cover;
}

.search-icon {
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
}
</style>
